module.exports = __webpack_public_path__ + "static/media/night_flight_sample_2.b0f743da.jpg";